import { useAuth } from '@cksoftware/react-base';
import { DlmsUser } from '../../../../../../globalModels/user/dlmsUser.ts';
import { Flex, IconButton, Link, useBreakpointValue, Image, ConditionalValue } from '@chakra-ui/react';
import infoIcon from '../../../../../../assets/infoIcon.png';
import videoIcon from '../../../../../../assets/videosIcon.png';
import catalogueIcon from '../../../../../../assets/pdfIcon.png';
import customerIcon from '../../../../../../assets/customerIcon.png';
import websiteLinkIcon from '../../../../../../assets/websiteLinkIcon.png';


export const AuctionCardLinks = (props: AuctionCardLinksProps) => {
  const {
    hideBelow,
    hideFrom,
    customerUrl,
    customerText,
    saleCatalogueUrl,
    saleCatalogueText,
    videoUrl,
    videoText,
    websiteLinkUrl,
    websiteLinkText,
    infoDocumentUrl,
    infoDocumentText
  } = props;
  const auth = useAuth<DlmsUser>();
  const isLoggedIn = auth.isAuthenticated;
  const isPurebred = true;

  return (
    <Flex
      hideBelow={hideBelow}
      hideFrom={hideFrom}
      fontSize={'md'}
      justify={{ base: 'flex-end', lg: 'start' }}
      gap={'4px'}
      direction={{ base: 'row', lg: 'column' }}>
      {isLoggedIn && isPurebred && <AuctionResponsiveLink url={'/Info/BuyerApproval'} text={'Buyer Approval'} />}
      {customerText && <AuctionResponsiveLink url={customerUrl} text={customerText} src={customerIcon} />}
      {saleCatalogueText && (
        <AuctionResponsiveLink url={saleCatalogueUrl} text={saleCatalogueText} src={catalogueIcon} />
      )}
      {videoText && <AuctionResponsiveLink url={videoUrl} text={videoText} src={videoIcon} />}
      {websiteLinkText && <AuctionResponsiveLink url={websiteLinkUrl} text={websiteLinkText} src={websiteLinkIcon} />}
      {infoDocumentText && <AuctionResponsiveLink url={infoDocumentUrl} text={infoDocumentText} src={infoIcon} />}
    </Flex>
  );
};

type AuctionCardLinksProps = {
  hideFrom?: any;
  hideBelow?: any;
  customerUrl?: string;
  customerText?: string;
  saleCatalogueUrl?: string;
  saleCatalogueText?: string;
  videoUrl?: string;
  videoText?: string;
  websiteLinkUrl?: string;
  websiteLinkText?: string;
  infoDocumentUrl?: string;
  infoDocumentText?: string;
};

const AuctionResponsiveLink = ({ url, text, src }: { url?: string; text: string; src?: string | undefined }) => {
  const isButton = useBreakpointValue({ base: true, lg: false });

  if (!src) return null;

  return isButton ? (
    <IconButton
      bg='transparent'
      onClick={(e) => {
        e.stopPropagation();
        window.location.href = url ?? '#';
      }}>
      <Image src={src} alt='Icon' />
    </IconButton>
  ) : (
    <Link width='auto' variant='underline' href={url} onClick={(e) => e.stopPropagation()}>
      {text}
    </Link>
  );
};
